var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87441",
    "data-name": "Group 87441",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.702,
    height: 24.599,
    viewBox: "0 0 25.702 24.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price-list",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87430",
    "data-name": "Group 87430",
    transform: "translate(3.514 8.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275611",
    "data-name": "Path 275611",
    d: "M85.11,171v9.036H73.564V171H70v11.044H88.674V171Z",
    transform: "translate(-70 -171)",
    fill: "#ffded7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_87431",
    "data-name": "Group 87431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275612",
    "data-name": "Path 275612",
    d: "M25.2,31.582h-.5V18.53a2.01,2.01,0,0,0-2.008-2.008H19.126V11.5a.5.5,0,0,0-.5-.5H7.078a.5.5,0,0,0-.5.5v5.02H3.012A2.01,2.01,0,0,0,1,18.53V31.582H.5a.5.5,0,0,0-.5.5V33.59A2.01,2.01,0,0,0,2.008,35.6H23.694A2.01,2.01,0,0,0,25.7,33.59V32.084A.5.5,0,0,0,25.2,31.582ZM7.58,12H18.122V27.566H7.58ZM2.008,18.53a1,1,0,0,1,1-1H6.576v10.04h-.5a.5.5,0,0,0,0,1H19.628a.5.5,0,0,0,0-1h-.5V17.526H22.69a1,1,0,0,1,1,1V31.582H2.008ZM24.7,33.59a1,1,0,0,1-1,1H2.008a1,1,0,0,1-1-1v-1H24.7Z",
    transform: "translate(0 -11)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275614",
    "data-name": "Path 275614",
    d: "M181.5,242h6.526a.5.5,0,0,0,0-1H181.5a.5.5,0,0,0,0,1Z",
    transform: "translate(-171.914 -229.454)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275615",
    "data-name": "Path 275615",
    d: "M181.5,292h6.526a.5.5,0,0,0,0-1H181.5a.5.5,0,0,0,0,1Z",
    transform: "translate(-171.914 -276.944)",
    fill: "#515255"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_275630",
    "data-name": "Path 275630",
    d: "M.959-8.844H3.42a1.351,1.351,0,0,0-.134-.388.889.889,0,0,0-.264-.3A1.276,1.276,0,0,0,2.6-9.724,2.284,2.284,0,0,0,2-9.793H.959v-.71H5.541v.71H3.877a1.7,1.7,0,0,1,.241.424,1.975,1.975,0,0,1,.124.525h1.3v.71H4.217a2.013,2.013,0,0,1-.5,1.038,2.037,2.037,0,0,1-1,.591v.02a1.8,1.8,0,0,1,.315.188,2.168,2.168,0,0,1,.274.246,2.952,2.952,0,0,1,.261.322q.129.183.277.416L5.14-3.227H4.176L3.019-5.166q-.167-.279-.317-.492a1.828,1.828,0,0,0-.32-.355,1.185,1.185,0,0,0-.375-.213A1.468,1.468,0,0,0,1.528-6.3H.959v-.7H2a1.446,1.446,0,0,0,.492-.084,1.426,1.426,0,0,0,.419-.233,1.4,1.4,0,0,0,.315-.36,1.492,1.492,0,0,0,.185-.464H.959Z",
    transform: "translate(9.799 13.488)",
    fill: "#fd930d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/Claim.cf14d6db22e3bd8940cd8710a25c5e81.svg";
export { ForwardRef as ReactComponent };